var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-bottom": "0" },
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "有效券包", name: "1" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "失效券包", name: "0" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "全部", name: "" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.query, size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "券包编号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "180px" },
                    attrs: { placeholder: "券包编号", clearable: "" },
                    model: {
                      value: _vm.query.packageCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "packageCode", $$v)
                      },
                      expression: "query.packageCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "券包名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "券包名称/别名", clearable: "" },
                    model: {
                      value: _vm.query.packageName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "packageName", $$v)
                      },
                      expression: "query.packageName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.resetSearch } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" }, attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "packageCode",
                  label: "券包编码",
                  width: "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "packageName",
                  label: "券包名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "券包别名", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row._editing
                          ? _c("el-input", {
                              staticStyle: { width: "110px" },
                              attrs: { size: "mini" },
                              model: {
                                value: row._alias,
                                callback: function ($$v) {
                                  _vm.$set(row, "_alias", $$v)
                                },
                                expression: "row._alias",
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(row.packageAlias || "-")),
                            ]),
                        _vm._v(" "),
                        row._editing
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "4px" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveAlias(row)
                                  },
                                },
                              },
                              [_vm._v("保存")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    row._editing = true
                                    row._alias = row.packageAlias
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "原价", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.oldPrice != null ? row.oldPrice + " 元" : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "售价", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.price != null ? row.price + " 元" : "-")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "封面图", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.pkgImgUrl
                          ? _c("el-image", {
                              staticStyle: {
                                width: "48px",
                                height: "48px",
                                "border-radius": "4px",
                              },
                              attrs: {
                                src: _vm.resPath + row.pkgImgUrl,
                                "preview-src-list": [
                                  _vm.resPath + row.pkgImgUrl,
                                ],
                                fit: "cover",
                              },
                            })
                          : _c("span", { staticStyle: { color: "#ccc" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "更新时间", width: "155", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.updateDate
                              ? _vm.parseTime(
                                  row.updateDate,
                                  "{y}-{m}-{d} {h}:{i}:{s}"
                                )
                              : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.isEnable === 1 ? "success" : "info",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.isEnable === 1 ? "已启用" : "已禁用"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "200",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openImgUpload(row)
                              },
                            },
                          },
                          [_vm._v("上传封面")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleEnable(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.isEnable === 1 ? "禁用" : "启用") +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("view-items", {
                                  id: row.id,
                                  packageName: row.packageName,
                                })
                              },
                            },
                          },
                          [_vm._v("查看券明细")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "16px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next",
                  "current-page": _vm.query.page,
                  "page-sizes": [10, 20, 50],
                  "page-size": _vm.query.limit,
                  total: _vm.total,
                },
                on: {
                  "current-change": function (p) {
                    _vm.query.page = p
                    _vm.fetchList()
                  },
                  "size-change": function (s) {
                    _vm.query.limit = s
                    _vm.query.page = 1
                    _vm.fetchList()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传券包封面",
            visible: _vm.imgDialog.visible,
            width: "360px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.imgDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _vm.imgDialog.current
                ? _c("el-image", {
                    staticStyle: {
                      width: "120px",
                      height: "120px",
                      "border-radius": "6px",
                      "margin-bottom": "12px",
                    },
                    attrs: {
                      src: _vm.resPath + _vm.imgDialog.current,
                      fit: "cover",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        loading: _vm.uploading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.imgInput.click()
                        },
                      },
                    },
                    [_vm._v("选择图片")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "imgInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: "image/*" },
                    on: { change: _vm.handleImgChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }